module.exports = __webpack_public_path__ + "static/BB_Bourbon-78.4711a8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_Bourbon-78.jpg
// module id = 448
// module chunks = 35783957827783